module.exports = __webpack_public_path__ + "img/pip-out.eb815315.svg";